import {wagmiConfig} from '#/wagmi/wagmi-config';
import {Land, testnetAccountFundingTargetAmounts} from '@shareland/shareland-common';
import {ERC20Mock__factory} from '@shareland/shareland-contracts';
import {Hex} from 'viem';
import {readContract, writeContract} from 'wagmi/actions';

export class ERC20Contract {
  account: Hex;
  contractAddress: Hex;

  constructor(account: Hex, contractAddress: Hex) {
    this.account = account;
    this.contractAddress = contractAddress;
  }

  async balanceOf() {
    return readContract(wagmiConfig, {
      abi: ERC20Mock__factory.abi,
      address: this.contractAddress,
      functionName: 'balanceOf',
      args: [this.account!],
      account: this.account,
    });
  }

  async allowance(account: Hex) {
    return readContract(wagmiConfig, {
      abi: ERC20Mock__factory.abi,
      address: this.contractAddress,
      functionName: 'allowance',
      args: [this.account, account],
      account: this.account,
    });
  }

  private async _approve(account: Hex, amount: number) {
    return writeContract(wagmiConfig, {
      abi: ERC20Mock__factory.abi,
      address: this.contractAddress,
      functionName: 'approve',
      args: [account, BigInt(Math.round(amount))],
      account: this.account,
    });
  }

  async approve(account: Hex, amount: number) {
    const allowance = await this.allowance(account);
    if (allowance >= amount) {
      return null;
    } else {
      return this._approve(account, amount);
    }
  }

  async transfer(account: Hex, amount: number) {
    return writeContract(wagmiConfig, {
      abi: ERC20Mock__factory.abi,
      address: this.contractAddress,
      functionName: 'transfer',
      args: [account, BigInt(Math.round(amount))],
      account: this.account,
    });
  }

  async approveLandTransaction(land: Land, amount: number) {
    return this.approve(land.contractAddresses.market, Math.round(amount));
  }

  async getFundingStatus() {
    return readContract(wagmiConfig, {
      abi: ERC20Mock__factory.abi,
      address: this.contractAddress,
      functionName: 'getFundingStatus',
      args: [this.account!],
      account: this.account,
    });
  }

  async fundAccount() {
    return writeContract(wagmiConfig, {
      abi: ERC20Mock__factory.abi,
      address: this.contractAddress,
      functionName: 'fundAccount',
      args: [this.account!],
      account: this.account,
    });
  }

  private async _giveAmountTo(account: Hex, amount: number) {
    return writeContract(wagmiConfig, {
      abi: ERC20Mock__factory.abi,
      address: this.contractAddress,
      functionName: 'giveAmountTo',
      args: [account, BigInt(Math.round(amount))],
      account: this.account,
    });
  }

  async getUSDC(amount = testnetAccountFundingTargetAmounts.usdc) {
    return this._giveAmountTo(this.account, amount);
  }
}
